import { z } from 'zod';
import { reminderRepeatKinds } from './recurrence.js';
/**
 * Emlekeztetok.
 *
 * Nem uzenet: nincs csatornaja, nincs sorszama, es nem is a folyamban jelenik
 * meg. Egyetlen dolga van - a megadott idopontban felhivja magara a figyelmet.
 *
 * ─── Miert kulon tipus, es miert nem "idozitett uzenet"? ─────────────────────
 *
 * Az idozitett uzenet a KULDES kesleltetese: a cimzett ugy latja, mintha
 * akkor irtak volna. Az emlekeztetot viszont eppen az teszi hasznossa, hogy
 * ATTORI a csendet: akkor is megjelenik, ha az illeto nemitva van. Ket
 * kulonbozo szandek, ket kulonbozo ut.
 *
 * ─── A nemitas attorese ─────────────────────────────────────────────────────
 *
 * Ez a rendszer EGYETLEN olyan ertesitese, ami nem nezi a nemitast. Pont
 * ezert nem szabad belole tobb: ha barmi mas is attorne, a nemitas elvesztene
 * a jelenteset, es a felhasznalo azt tanulna meg, hogy nem er semmit.
 */
/** Ennyivel kesobbre lehet legkorabban emlekeztetot kerni. */
export const MIN_REMINDER_LEAD_MS = 60_000;
/** Legfeljebb ennyire elore - ugyanaz a hatar, mint az idozitett uzenetnel. */
export const MAX_REMINDER_AHEAD_MS = 90 * 24 * 60 * 60 * 1000;
/** A szoveg rovid: ez egy emlekezteto, nem level. */
export const MAX_REMINDER_TEXT = 500;
/**
 * Az ismetlodes leirasa - a szabaly, nem a kovetkezo idopont.
 *
 * A kovetkezo alkalom SZAMITOTT ertek (`nextOccurrence`), es azt a szerver
 * lepteti tovabb minden kikuldes utan. Amit tarolunk, az a szandek.
 */
export const repeatRuleSchema = z.object({
    kind: z.enum(reminderRepeatKinds),
    /** `weekly` eseten a napok. 0 = vasarnap, ahogy a munkaidonel is. */
    days: z.array(z.number().int().min(0).max(6)).max(7),
    /** Meddig ismetlodjon. `null` = amig vissza nem vonjak. */
    until: z.string().nullable(),
    /** A sorozat elso alkalma - a havi ismetlodes ebbol veszi a nap sorszamat. */
    anchor: z.string().nullable(),
    /** Melyik zonaban ertendo a "reggel 9". A kero zonaja a beallitaskor. */
    timeZone: z.string(),
});
export const reminderSchema = z.object({
    id: z.string(),
    text: z.string(),
    remindAt: z.string(),
    createdAt: z.string(),
    /** Ki kerte. A cimzettek ezt latjak: "Emlekezteto Annatol". */
    creatorId: z.string(),
    /**
     * Kiknek szol - a KIBONTOTT lista, a csoportok tagjaival egyutt.
     *
     * Ez mindig a MOSTANI allapot: a csoport tagsaga valtozhat a beallitas es
     * a lejarat kozott, es a lejaratkori szamit.
     */
    targetIds: z.array(z.string()),
    /** Mely csoportoknak szol. A felulet igy tudja "@fejlesztok"-kent mutatni. */
    groupIds: z.array(z.string()),
    /** Kitoltve, ha mar kiment. Ismetlodonel mindig `null`: jon meg. */
    sentAt: z.string().nullable(),
    repeat: repeatRuleSchema,
});
export const createReminderInput = z.object({
    text: z.string().min(1).max(MAX_REMINDER_TEXT),
    remindAt: z.string(),
    /**
     * A cimzettek. URES lista = csak magadnak.
     *
     * A leggyakoribb eset a sajat emlekezteto, ezert nem kotelezo kitolteni -
     * a szerver ilyenkor a kerot teszi be cimzettnek.
     */
    targetIds: z.array(z.string()).max(100).optional(),
    /**
     * Csoport-cimzettek.
     *
     * A csoportot NEM bontjuk fel taglistara: a lejaratkori tagsag szamit.
     * Aki kozben belep a csoportba, az is megkapja - epp ezert erdemes
     * csoportot valasztani, nem embereket egyesevel.
     */
    groupIds: z.array(z.string()).max(20).optional(),
    /**
     * Ismetlodes. Hianyzo mezo = egyszeri emlekezteto.
     *
     * Az idozona SZANDEKOSAN nincs benne: a szerver a kero profiljabol veszi.
     * Egy klienstol kapott zona elgepelheto es hamisithato is, a "reggel 9"
     * jelentese pedig ezen mulik.
     */
    repeat: z
        .object({
        kind: z.enum(reminderRepeatKinds),
        days: z.array(z.number().int().min(0).max(6)).max(7).optional(),
        until: z.string().nullable().optional(),
    })
        .optional(),
});
/**
 * Egy MEGTORTENT kikuldes - az elozmenyhez.
 *
 * Az ismetlodo emlekezteto egyetlen sor az `reminders` tablaban, de sokszor
 * szolal meg. Az elozmeny ezekrol az alkalmakrol szol: mikor jott, es
 * nyugtaztam-e. A nyugtazas SZEMELYES: ugyanaz a csapatnak szolo emlekezteto
 * masnak meg nyitott lehet.
 */
export const reminderHistoryEntrySchema = z.object({
    /** A kikuldes azonositoja - a nyugtazas erre hivatkozik. */
    deliveryId: z.string(),
    reminderId: z.string(),
    text: z.string(),
    creatorId: z.string(),
    /** Melyik alkalom volt ez. */
    remindAt: z.string(),
    sentAt: z.string(),
    /** Mikor pipaltam ki. `null` = meg nyitott. */
    ackedAt: z.string().nullable(),
    /** Ismetlodik-e - ebbol latszik, hogy jon meg. */
    repeatKind: z.enum(reminderRepeatKinds),
});
//# sourceMappingURL=reminder.js.map